import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white">
            <h5 className="text-white">
              <br />
              <br />
            </h5>
          </Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With your extensive experience in retail banking across different institutions,
                how has the landscape of retail banking evolved in Egypt over the past decade,
                particularly with the rise of digital transformation?
              </strong>
            </h5>

            <h5 className="text-white">
              Over the past decade, Egypt’s retail banking sector has undergone a profound
              transformation, driven largely by digital innovation and bold regulatory initiatives.
              We’ve moved from traditional, branch-dependent banking to an era where customers
              expect and receive instant, seamless access to financial services anytime, anywhere.
              <br />
              <br />
              Online and mobile banking platforms now empower customers to manage their accounts,
              transfer money, and pay bills with unprecedented ease. The Central Bank of Egypt has
              played a pivotal role in accelerating this shift, launching key initiatives like the
              'Meeza' national payment scheme, which streamlined government payments and expanded
              financial inclusion.
              <br />
              <br />
              The introduction of InstaPay in 2022 marked another breakthrough, enabling real-time,
              24/7 instant money transfers — a service that’s already attracted over 12.5 million
              users. Most recently, tokenization has emerged as a game-changer, enhancing both
              security and convenience by transforming card details into digital tokens for safer,
              faster payments via mobile wallets. The successful rollout of Apple Pay is a testament
              to this progress, encouraging even more Egyptians to embrace cashless transactions.
              <br />
              <br />
              In short, retail banking in Egypt has evolved from a slow, paperwork-heavy process to
              a dynamic, customer-centric experience — faster, more secure, and accessible to a
              larger segment of the population than ever before.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- As Head of Retail Banking, what are the key strategic pillars that guide your
                approach to optimizing profitability while enhancing customer experience?
              </strong>
            </h5>
            <h5 className="text-white">
              The key strategic pillars for optimizing profitability while enhancing customer
              experience can be summarized as follows:
              <br />
              <ol>
                <li>
                  Customer-Centric Approach: Prioritize understanding and addressing customer needs
                  by offering seamless, fast, and personalized banking solutions that align with
                  their evolving lifestyles.
                </li>
                <li>
                  Diversified Product Portfolio: Provide a wide range of financial and non-financial
                  products tailored to different customer segments, ensuring solutions that fit
                  their unique financial goals and everyday needs.
                </li>
                <li>
                  Digital-First Innovation: Continuously integrate digital advancements into
                  products and services to drive efficiency, lower operational costs, and deliver
                  better pricing, enhanced benefits, and a more intuitive banking experience.
                </li>
              </ol>
              <br />
              By strategically balancing these pillars, banks can unlock sustainable profitability
              while fostering deeper customer loyalty and satisfaction.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Digital transformation has become a cornerstone in the banking industry. How is
                Mashreq Bank leveraging digital innovation to deliver seamless and customer-centric
                banking services?
              </strong>
            </h5>
            <h5 className="text-white">
              At Mashreq Egypt, digital innovation isn’t just a priority — it’s a core pillar
              driving our mission to transform the customer experience and expand our product
              offerings. We continuously leverage technology to create faster, more convenient, and
              highly personalized banking services.
              <br />
              <br />
              Our Mashreq mobile banking app is designed to offer an intuitive, all-in-one
              experience, supported by AI-driven chatbots that provide instant, round-the-clock
              assistance and tailored financial insights. One of our most significant breakthroughs
              is the launch of Mashreq NEO and e& Mashreq NEO, reshaping how Egyptians interact with
              banking. With these digital-first solutions, customers — including young Egyptians
              from the age of 15 — can open an account within minutes through the Mashreq Egypt
              mobile app. To complete the activation, they can visit any Mashreq branch, Fawry Plus,
              or e& store nationwide, ensuring maximum accessibility. We’ve also integrated
              essential services like Certificates of Deposit (CDs) and Money Market Certificates
              (MMCs) directly into the app, enabling customers to manage their savings with ease. In
              a first-of-its-kind collaboration with e&, Mashreq became the first bank in Egypt to
              allow customers to open an account directly through the e& app.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Financial inclusion is a critical objective in Egypt. What initiatives or
                partnerships is Mashreq Bank undertaking to promote financial inclusion and support
                underserved communities?
              </strong>
            </h5>
            <h5 className="text-white">
              Building on our commitment to innovation, Mashreq Egypt is equally dedicated to
              driving financial inclusion, ensuring banking services are accessible to all —
              particularly underserved and unbanked communities. Our approach extends beyond
              traditional banking models, focusing on removing barriers and simplifying access. With
              the launch of Mashreq Neo and e& Mashreq Neo, we’re empowering more Egyptians —
              including youth as young as 15 — to seamlessly enter the financial system. By
              integrating account opening and key banking services directly into the Mashreq Egypt
              app, we’ve eliminated the need for in-branch visits. This breakthrough is particularly
              crucial for reaching individuals in remote areas or those with limited mobility.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- With the competitive banking landscape in Egypt, what differentiates Mashreq
                Bank’s retail offerings, and how do you ensure a unique value proposition for your
                customers?
              </strong>
            </h5>
            <h5 className="text-white">
              At Mashreq Egypt, we’re reshaping the future of banking — merging innovation,
              convenience, and value to set new standards in customer experience.
              <br />
              <br />
              Through Mashreq Neo and e& Mashreq Neo, we’re redefining accessibility by enabling
              customers to open accounts digitally within minutes. From there, we offer a suite of
              tailored financial products — including the Mashreq Neo card, current accounts,
              certificates with fixed monthly returns, the Mashreq Millionaire certificate, and an
              exclusive loyalty program — all designed to meet the diverse needs of different
              customer segments.
              <br />
              <br />
              What truly sets us apart, however, is our commitment to value-driven rewards and
              dynamic campaigns. A prime example is our recent 23% savings campaign on Mashreq Neo
              and e& Mashreq Neo accounts, offering the highest annual return in Egypt for balances
              starting from EGP 5,000, with daily interest calculation and monthly payouts — giving
              customers more flexibility and control over their savings. Additionally, we’re keeping
              things exciting with our 90% cashback weekend offers, rotating across different
              sectors like restaurants, fashion, and cafés — turning everyday spending into
              extraordinary savings.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- As a leader with such an extensive background, what advice would you give to
                young professionals aspiring to build a career in the banking and financial services
                industry?
              </strong>
            </h5>
            <h5 className="text-white">
              For young professionals aiming to build a thriving career in banking and financial
              services, my advice is to focus on five key pillars:
              <ul>
                <li>
                  Adopt a Customer-Centric Mindset – The foundation of success in banking is
                  understanding customer needs and delivering solutions that truly add value.{" "}
                </li>
                <li>
                  Stay Ahead of Market Dynamics – The financial landscape is constantly evolving.
                  Keep yourself updated on industry trends, market movements, and emerging
                  technologies to stay competitive and informed.
                </li>
                <li>
                  Embrace Digital Innovation – The future of banking is being shaped by fintech,
                  blockchain, AI, and data analytics. Cultivating a strong understanding of these
                  technologies will position you as a forward-thinking professional.
                </li>
                <li>
                  Develop Analytical and Problem-Solving Skills – Data is the driving force behind
                  informed decisions. Strengthen your ability to interpret complex data, extract
                  insights, and turn them into actionable strategies.
                </li>
                <li>
                  Cultivate Adaptability and Resilience – The banking sector is fast-paced and
                  ever-changing. Those who succeed are agile, willing to learn, and unafraid of
                  stepping outside their comfort zones.
                </li>
              </ul>
              <br />A successful career in banking isn’t built overnight — it’s driven by continuous
              learning, adaptability, and a passion for innovation.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Looking ahead, what are the key trends and innovations you foresee shaping the
                future of retail banking in Egypt and the wider region?
              </strong>
            </h5>
            <h5 className="text-white">
              The future of retail banking in Egypt and the wider region is set to be reshaped by a
              wave of transformative trends and innovations:
              <ol>
                <li>
                  Digital-First Banking Ecosystems – With the rise of eKYC and streamlined digital
                  onboarding, the shift to mobile and online banking will accelerate. Banks will
                  prioritize frictionless, intuitive, and personalized digital journeys — making
                  branches more of an advisory hub than a transactional necessity.
                </li>
                <li>
                  AI and Automation Redefining Engagement – From AI-powered chatbots to
                  robo-advisors and hyper-personalized financial insights, advanced analytics will
                  elevate customer service, boost operational efficiency, and help predict customer
                  needs before they arise.
                </li>
                <li>
                  Next-Gen Payment Solutions – Contactless payments, biometric authentication, and
                  tokenization will become the norm, offering faster, safer, and more convenient
                  ways to transact — both locally and cross-border.
                </li>
                <li>
                  Financial Inclusion Through Innovation – Expanding access to banking services will
                  remain a critical focus. Banks will increasingly leverage digital wallets,
                  microfinance solutions, and mobile banking platforms to reach underserved and
                  unbanked communities, driving economic empowerment.
                </li>
                <li>
                  Sustainability and ESG-Driven Banking – Green financing, sustainable lending
                  models, and environmentally-conscious products will gain momentum as both
                  customers and regulators push for more responsible banking practices.
                </li>
              </ol>
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
